import { Match } from './match.model';
import { Report } from './report.model';
import { Template } from './template.model';

export class TemplateViewModel extends Template {
  report: Report;
  match: Match;
}
